<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row align="center" justify="center">
        <v-col>
          <h3>
            <v-icon large>mdi-city-variant-outline</v-icon> Configurar -
            {{ $route.params.id }}
          </h3>
        </v-col>
        <v-col cols="2" class="text-right">
          <TheButton
            text="Voltar"
            icon="mdi-chevron-left"
            color="blue"
            @click="back()"
          />
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-5 mb-5 elevation-hb" v-if="seller">
      <v-row>
        <v-col>
          <v-select
            :items="types"
            v-model="seller.integrationType"
            label="Tipo de Integração"
            outlined
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <TheInput v-model="seller.integrationToken" label="Token" />
        </v-col>
        <v-col>
          <TheInput
            v-model="seller.integrationWarehouseName"
            label="Nome do Depósito"
            mask="#####-###"
          />
        </v-col>
        <v-col v-if="seller.integrationType === 'Bling'">
          <TheInput
            v-model="seller.blingStoreId"
            label="Id Loja/Vendedor Bling"
          ></TheInput>
        </v-col>
        <v-col>
          <v-switch
            v-model="seller.orderCreateOnFullfillFlag"
            label="Criação de Pedido no Pagamento"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col><TheInput v-model="seller.sellerCnpj" label="CNPJ" /></v-col>
        <v-col cols="8"
          ><TheInput v-model="seller.socialName" label="Razão Social"
        /></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"
          ><TheInput v-model="seller.sellerEmail" label="Email"
        /></v-col>
        <v-col cols="4"
          ><TheInput v-model="seller.sellerPhone" label="Telefone"
        /></v-col>
        <v-col cols="4">
          <v-switch
            v-model="seller.active"
            :label="seller.active ? 'Ativo' : 'Desativado'"
          ></v-switch>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <TheButton
        text="Salvar"
        icon="mdi-content-save"
        color="green"
        @click="saveSeller()"
      />
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError } from "@/global";

import TheInput from "@/components/TheInput";
import TheButton from "@/components/TheButton";

export default {
  name: "SellersAddress",
  components: {
    TheInput,
    TheButton,
  },
  data: () => ({
    seller: {},
    loading: false,
    types: [
      { text: "Manual", value: "Manual" },
      { text: "Bling", value: "Bling" },
      { text: "Datasul", value: "Datasul" },
      { text: "Api", value: "Api" },
      { text: "Customizada", value: "Customizada" },
    ],
  }),
  methods: {
    loadSeller() {
      const id = this.$route.params.id;
      const url = `${baseApiUrl}/seller/${id}`;
      axios
        .get(url)
        .then((res) => {
          this.seller = res.data;
        })
        .catch(showError);
    },
    saveSeller() {
      const id = this.$route.params.id;
      const url = `${baseApiUrl}/seller/${id}`;
      axios
        .put(url, this.seller)
        .then((res) => {
          this.$router.push({ name: "sellers" });
        })
        .catch(showError);
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    this.loadSeller();
  },
};
</script>

<style></style>
